import { getCombinedElement } from '../PageStore/utils';
import { Element } from '../types';
import { PreviewStore } from './PreviewStore';

export const getPreviewElement = (elementId: string, previewStore: PreviewStore): Element | undefined => {
  return getCombinedElement({ id: elementId }, previewStore.previewElements, previewStore.previewBreakpointElements);
};
